import { error99, GradeProduto, ProdAttributes, ProdImages, Produto, ProdutoEstoque, RetAPI, VariacaoProduto } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const ProdutoService = {

    /*
    FilterRelatorio: async (filterProduto?: any): Promise<Produto[]> => {

        const resp = await Api('Produto/Report/Filter', 'get', {

            datai: filterProduto.datai,
            dataf: filterProduto.dataf,
            id_marca: filterProduto.id_marca,
            id_grupo: filterProduto.id_grupo,
            id_subgrupo: filterProduto.id_subgrupo,
            tipo_produto: filterProduto.tipo_produto,
            ativo: filterProduto.ativo,
            tipo_estoque: filterProduto.tipo_estoque

        })
        const produtos: Produto[] = []

        if (resp.data) {
            if (resp.data.error && resp.data.error === '0') {
                resp.data.produtos.map((item: any) => {

                    return produtos.push({
                        id: item.id_prod,
                        id_empresa: item.id_empresa,
                        id_grupo: {
                            id: item.id_grupo,
                            description: item.desc_grupo,

                        },
                        id_marca: {
                            id: item.id_marca,
                            description: item.desc_marca,

                        },
                        id_sgrupo: {
                            id: item.id_sgrupo,
                            description: item.desc_sgrupo,

                        },
                        id_tributacao: {
                            id: item.id_tributacao,
                            descricao: item.desc_gtrib,
                            pICMS: item.aliq_icms,
                            pPIS: item.aliq_pis,
                            pCOFINS: item.aliq_cofins,
                            cstPisCofins: item.cst_pis_cofins,
                            cfopSDentro: item.cfop_saida_dentro,
                            cfopSFora: item.cfop_saida_fora,
                            cfopEdentro: item.cfop_entrada_dentro,
                            cfopEfora: item.cfop_entrada_fora,
                            cstICMSDentro: item.cst_icms_dentro,
                            cstICMSFora: item.cst_icms_fora
                        },
                        id_unid_medida: {
                            id: item.id_unid_medida,
                            description: item.desc_unid,
                            fator_conversao: item.fator_conversao
                        },
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        descricao: item.descricao,
                        referencia: item.referencia,
                        preco_v: item.preco_v,
                        preco_c: item.preco_c,
                        cod_barra: item.cod_barra,
                        peso: item.peso,
                        estoque: item.estoque,
                        estoque_fisico: item.estoque_fisico,
                        estoque_minimo: item.estoque_minimo,
                        ativo: item.ativo,
                        ncm: item.ncm,
                        cod_cest: item.cod_cest,
                        origem_mercadoria: item.origem_mercadoria,
                        tipo: item.tipo,
                        urlImage: item.url,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete,

                        description: item.descricao

                    })
                })

                return produtos
            } else {
                return []
            }
        } else {
            return []
        }

    },
    */

    /*
    VariacaoList: async (descricao?: string): Promise<RetAPI> => {
        const resp = await Api('VariacaoProduto/list', 'get', { descricao })
        let variacaoProduto = {}

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.variacaoList) {
                    variacaoProduto = await resp.data.variacaoList.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.descricao
                        }
                    })
                }

                
            } 

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

        return {
            error: false,
            msg: '',
            data: variacaoProduto,
        }
    },
    */

    GetGradeProduto: async (idProd: string): Promise<GradeProduto[]> => {

        const resp = await Api('GradeProduto/List', 'get', { id_produto: idProd })

        let gradeList: GradeProduto[] = []

        if (resp.data && resp.data.grade) {
            gradeList = resp.data.grade.map((item: any) => {
                return {
                    id: item.id,
                    valorEntrada: 0,
                    idProduto: item.id_produto,
                    codBarraRef: item.cod_barra_ref,
                    variacao: {
                        id: item.id_variacao,
                        description: item.desc_variacao,
                        tipo: "V"
                    },
                    subVariacao: {
                        id: item.id_sub_variacao,
                        description: item.desc_sub_variacao,
                        tipo: "S"
                    },
                    saldoEstoque: item.saldo_estoque,
                }
            })
        }

        return gradeList
    },

    GetGradeProdutoPorCodBarra: async (codBarra: string): Promise<RetAPI> => {

        const resp = await Api('GradeProduto/ListCodBarra', 'get', { cod_barra: codBarra })

        let retorno: RetAPI = {error: false}

        let gradeList: GradeProduto[] = []

        if (resp.data && resp.data.grade) {
            
            gradeList = resp.data.grade.map((item: any) => {
                return {
                    id: item.id,
                    valorEntrada: 0,
                    idProduto: item.id_produto,
                    codBarraRef: item.cod_barra_ref,
                    variacao: {
                        id: item.id_variacao,
                        description: item.desc_variacao,
                        tipo: "V"
                    },
                    subVariacao: {
                        id: item.id_sub_variacao,
                        description: item.desc_sub_variacao,
                        tipo: "S"
                    },
                    saldoEstoque: item.saldo_estoque,
                }
            })

            retorno.data = gradeList

            if (resp.data.id_produto){
                retorno.id = resp.data.id_produto // Retorna o id do produto caso não tenha grade
            }

            if (gradeList.length === 0 && !resp.data.id_produto){
                retorno.error = true
                retorno.msg = "Código de barras não localizado"
            }

        }

        return retorno
    },

    GetAttributesGrade: async (): Promise<RetAPI> => {

        const resp = await Api('GradeProduto/attributes', 'get')
        const gradeAttributes: VariacaoProduto[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: gradeAttributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.variacaoList) {
                    resp.data.variacaoList.map((variacao: any) => {
                        gradeAttributes.push({
                            id: variacao.id,
                            description: variacao.descricao,
                            tipo: variacao.tipo === "S" ? "S" : "V"
                        })
                    })
                }


            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: gradeAttributes
            }
        }

        return {
            error: false,
            data: gradeAttributes
        }
    },

    LancarGrade: async (tipo: string, gradesList: string): Promise<RetAPI> => {

        const resp = await Api('AcertoEstoque/LancaGradeMassa', 'post', { tipo: tipo, grades: gradesList })

        if (resp.data) {
            return {
                error: resp.data.error === "1",
                msg: resp.data.msg || "",
            }
        }

        return {
            error: false,
            msg: '',
        }
    },

    GetAttributes: async (idProd?: string): Promise<RetAPI> => {

        const resp = await Api('Produto/attributes', 'get', { idProd })
        const prodAttributes: ProdAttributes = {
            grupos: [],
            sgrupos: [],
            marcas: [],
            gTrib: [],
            unidades: [],
            imagens: [],
            variacaoProdutos: [],
            grade: [],
            produto: {
                id: 0,
                id_empresa: 0,
                id_grupo: {
                    id: 0,
                    description: '',
                    dt_cadastro: '',
                    dt_last_update: '',
                    id_user_insert: 0,
                    name_user_insert: '',
                    name_user_last_update: ''
                },
                id_marca: {
                    id: 0,
                    description: '',
                    dt_cadastro: '',
                    dt_last_update: '',
                    id_user_insert: 0,
                    name_user_insert: '',
                    name_user_last_update: ''
                },
                id_sgrupo: {
                    id: 0,
                    description: '',
                    dt_cadastro: '',
                    dt_last_update: '',
                    id_user_insert: 0,
                    name_user_insert: '',
                    name_user_last_update: ''
                },
                id_tributacao: {
                    id: 0,
                    cfopEdentro: '',
                    cfopEfora: '',
                    cfopSDentro: '',
                    cfopSFora: '',
                    cstICMSDentro: '',
                    cstICMSFora: '',
                    cstPisCofins: '',
                    descricao: '',
                    dt_cadastro: '',
                    dt_last_update: '',
                    id_user_insert: 0,
                    name_user_insert: '',
                    name_user_last_update: '',
                    pCOFINS: 0,
                    pICMS: 0,
                    pPIS: 0,
                    description: ''
                },
                id_unid_medida: {
                    id: 0,
                    description: '',
                    fator_conversao: 0,
                    dt_cadastro: '',
                    dt_last_update: '',
                    id_user_insert: 0,
                    name_user_insert: '',
                    name_user_last_update: ''
                },
                id_user_insert: 0,
                id_user_last_update: 0,
                id_user_exclusao: 0,
                dt_cadastro: '',
                dt_last_update: '',
                dh_exclusao: '',
                motivo_exclusao: '',
                descricao: '',
                cod_barra: '',
                referencia: '',
                preco_c: 0,
                preco_v: 0,
                peso: 0,
                estoque_minimo: 0,
                ativo: true,
                ncm: '',
                cod_cest: '',
                origem_mercadoria: '0',
                tipo: 'P',
                estoque: 0,
                estoque_fisico: 0,
                urlImage: '',
                name_user_insert: '',
                name_user_last_update: '',
                name_user_delete: '',
                description: '',
            }
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: prodAttributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                prodAttributes.descVariacao = resp.data.desc_variacao
                prodAttributes.descSubVariacao = resp.data.desc_sub_variacao

                if (resp.data.grupos) {
                    resp.data.grupos.map((item: any) => {
                        prodAttributes.grupos.push({
                            id: item.id,
                            description: item.descricao,

                        })
                    })
                }

                if (resp.data.grade) {
                    resp.data.grade.map((item: any) => {
                        prodAttributes.grade.push({
                            id: item.id,
                            idProduto: item.id_produto,
                            codBarraRef: item.cod_barra_ref,
                            variacao: { id: item.id_variacao, description: item.desc_variacao, tipo: item.tipo },
                            subVariacao: { id: item.id_sub_variacao, description: item.desc_sub_variacao, tipo: item.tipo },
                            saldoEstoque: item.saldo_estoque,
                        })
                    })
                }

                if (resp.data.sub_grupos) {
                    resp.data.sub_grupos.map((item: any) => {
                        prodAttributes.sgrupos.push({
                            id: item.id,
                            description: item.descricao
                        })
                    })
                }

                if (resp.data.marcas) {
                    resp.data.marcas.map((item: any) => {
                        prodAttributes.marcas.push({
                            id: item.id,
                            description: item.descricao,

                        })
                    })
                }

                if (resp.data.unidades_medidas) {
                    resp.data.unidades_medidas.map((unid: any) => {
                        prodAttributes.unidades.push({
                            id: unid.id,
                            description: unid.descricao,
                            fator_conversao: unid.fator_conversao
                        })
                    })
                }

                if (resp.data.grupos_tributacao) {
                    resp.data.grupos_tributacao.map((gtrib: any) => {
                        prodAttributes.gTrib.push({
                            id: gtrib.id,
                            descricao: gtrib.descricao,
                            pICMS: gtrib.aliq_icms,
                            pPIS: gtrib.aliq_pis,
                            pCOFINS: gtrib.aliq_cofins,
                            cstPisCofins: gtrib.cst_pis_cofins,
                            cfopSDentro: gtrib.cfop_saida_dentro,
                            cfopSFora: gtrib.cfop_saida_fora,
                            cfopEdentro: gtrib.cfop_entrada_dentro,
                            cfopEfora: gtrib.cfop_entrada_fora,
                            cstICMSDentro: gtrib.cst_icms_dentro,
                            cstICMSFora: gtrib.cst_icms_fora,
                            description: gtrib.descricao
                        })
                    })
                }

                if (resp.data.variacaoList) {
                    resp.data.variacaoList.map((variacao: any) => {
                        prodAttributes.variacaoProdutos?.push({
                            id: variacao.id,
                            description: variacao.descricao,
                            tipo: variacao.tipo === "S" ? "S" : "V"
                        })
                    })
                }

                if (resp.data.prod) {
                    resp.data.prod.imagens.map((item: any) => {
                        prodAttributes.imagens?.push({
                            id: item.id,
                            idProd: item.id_prod,
                            url: item.url,
                        })
                    })

                    if (prodAttributes.produto) {

                        prodAttributes.produto.id = resp.data.prod?.id
                        prodAttributes.produto.descricao = resp.data.prod?.descricao
                        prodAttributes.produto.estoque = resp.data.prod?.estoque
                        prodAttributes.produto.peso = resp.data.prod?.peso
                        prodAttributes.produto.preco_c = resp.data.prod?.preco_c
                        prodAttributes.produto.preco_v = resp.data.prod?.preco_v
                        prodAttributes.produto.estoque_fisico = resp.data.prod?.estoque_fisico
                        prodAttributes.produto.estoque_minimo = resp.data.prod?.estoque_minimo
                        prodAttributes.produto.ativo = resp.data.prod?.ativo === 'S'
                        prodAttributes.produto.ncm = resp.data.prod?.ncm
                        prodAttributes.produto.referencia = resp.data.prod?.referencia
                        prodAttributes.produto.cod_cest = resp.data.prod?.cod_cest
                        prodAttributes.produto.origem_mercadoria = resp.data.prod?.origem_mercadoria
                        prodAttributes.produto.tipo = resp.data.prod?.tipo
                        prodAttributes.produto.cod_barra = resp.data.prod?.cod_barra
                        prodAttributes.produto.id_marca = { id: resp.data.prod.marca?.id, description: resp.data.prod.marca?.descricao }
                        prodAttributes.produto.id_grupo = { id: resp.data.prod.grupo?.id, description: resp.data.prod.grupo?.descricao }
                        prodAttributes.produto.id_sgrupo = { id: resp.data.prod.sgrupo?.id, description: resp.data.prod.sgrupos?.descricao }
                        prodAttributes.produto.id_unid_medida = { id: resp.data.prod.unid?.id, description: resp.data.prod.unid?.descricao, fator_conversao: resp.data.prod.unid?.fator_conversao }
                        prodAttributes.produto.id_tributacao = {
                            id: resp.data.prod.gtrib?.id,
                            descricao: resp.data.prod.gtrib?.desc_gtrib,
                            pICMS: resp.data.prod.gtrib?.pICMS,
                            pPIS: resp.data.prod.gtrib?.pPIS,
                            pCOFINS: resp.data.prod.gtrib?.pCOFINS,
                            cstPisCofins: resp.data.prod.gtrib?.cst_pis_cofins,
                            cfopSDentro: resp.data.prod.gtrib?.cfop_saida_dentro,
                            cfopSFora: resp.data.prod.gtrib?.cfop_saida_fora,
                            cfopEdentro: resp.data.prod.gtrib?.cfop_entrada_dentro,
                            cfopEfora: resp.data.prod.gtrib?.cfop_entrada_fora,
                            cstICMSDentro: resp.data.prod.gtrib?.cst_icms_dentro,
                            cstICMSFora: resp.data.prod.gtrib?.cst_icms_fora,
                            description: resp.data.prod.gtrib?.desc_gtrib
                        }

                        prodAttributes.produto.id_user_insert = resp.data.prod?.id_user_insert
                        prodAttributes.produto.id_user_last_update = resp.data.prod?.id_user_last_update
                        prodAttributes.produto.id_user_exclusao = resp.data.prod?.id_user_exclusao
                        prodAttributes.produto.name_user_insert = resp.data.prod?.name_user_insert
                        prodAttributes.produto.name_user_last_update = resp.data.prod?.name_user_last_update
                        prodAttributes.produto.name_user_delete = resp.data.prod?.name_user_delete
                        prodAttributes.produto.dt_cadastro = resp.data.prod?.dt_cadastro
                        prodAttributes.produto.dt_last_update = resp.data.prod?.dt_last_update
                        prodAttributes.produto.dh_exclusao = resp.data.prod?.dh_exclusao

                    }
                }

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: prodAttributes
            }
        }

        return {
            error: false,
            data: prodAttributes
        }
    },

    Save: async (produto: Produto, imageList?: Array<ProdImages>): Promise<RetAPI> => {

        const resp = await Api('Produto/save', 'post', { produto })
        let imagens: ProdImages[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            const formData = new FormData()

            if (imageList?.length) {
                const idProd = resp.data.id
                formData.append('idProd', idProd)
                for (let i in imageList) {
                    formData.append('imagem[' + i + ']', imageList[i].imagem || '')
                }

                const respImage = await Api('Produto/Image/SaveImageList', 'post', formData)

                if (respImage.data) {

                    if (respImage.data.imagens) {
                        imagens = await respImage.data.imagens.map((item: any) => {
                            return {
                                id: item.id,
                                idProd: item.id_prod,
                                url: item.url,
                            }
                        })
                    }

                    if (respImage.data.error && respImage.data.error === '1') {
                        return {
                            error: true,
                            msg: respImage.data.msg,
                            id: 0,
                            data: imagens
                        }
                    }
                }

            }

            return {
                error: false,
                msg: 'Dados do produto gravados com sucesso',
                id: resp.data.id,
                data: resp.data,
                dt_cadastro: resp.data.prod.dt_cadastro,
                dt_last_update: resp.data.prod.dt_last_update,
                name_user_insert: resp.data.prod.name_user_insert,
                name_user_last_update: resp.data.prod.name_user_last_update,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Produto/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter: string, type: string, filterProduto?: any): Promise<RetAPI> => {

        const resp = await Api('Produto/filter', 'get', {
            field,
            filter,
            type,
            dt_cad_ini: filterProduto?.dt_cad_ini,
            dt_cad_fim: filterProduto?.dt_cad_fim,
            id_marca: filterProduto?.id_marca,
            id_grupo: filterProduto?.id_grupo,
            id_subgrupo: filterProduto?.id_subgrupo,
            tipo_produto: filterProduto?.tipo_produto,
            status: filterProduto?.status,
            tipo_estoque: filterProduto?.tipo_estoque,
            id_tributacao: filterProduto?.id_tributacao
        })
        const produtos: Produto[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: produtos
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.produtos.map((item: any) => {

                    return produtos.push({
                        id: item.id_prod,
                        id_empresa: item.id_empresa,
                        id_grupo: {
                            id: item.id_grupo,
                            description: item.desc_grupo,
                        },
                        id_marca: {
                            id: item.id_marca,
                            description: item.desc_marca,

                        },
                        id_sgrupo: {
                            id: item.id_sgrupo,
                            description: item.desc_sgrupo,

                        },
                        id_tributacao: {
                            id: item.id_tributacao,
                            descricao: item.desc_gtrib,
                            pICMS: item.aliq_icms,
                            pPIS: item.aliq_pis,
                            pCOFINS: item.aliq_cofins,
                            cstPisCofins: item.cst_pis_cofins,
                            cfopSDentro: item.cfop_saida_dentro,
                            cfopSFora: item.cfop_saida_fora,
                            cfopEdentro: item.cfop_entrada_dentro,
                            cfopEfora: item.cfop_entrada_fora,
                            cstICMSDentro: item.cst_icms_dentro,
                            cstICMSFora: item.cst_icms_fora,
                            description: item.desc_gtrib
                        },
                        id_unid_medida: {
                            id: item.id_unid_medida,
                            description: item.desc_unid,
                            fator_conversao: item.fator_conversao
                        },
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        descricao: item.descricao,
                        referencia: item.referencia,
                        preco_v: item.preco_v,
                        preco_c: item.preco_c,
                        cod_barra: item.cod_barra,
                        peso: item.peso,
                        estoque: item.estoque,
                        estoque_fisico: item.estoque_fisico,
                        estoque_minimo: item.estoque_minimo,
                        ativo: item.ativo,
                        ncm: item.ncm,
                        cod_cest: item.cod_cest,
                        origem_mercadoria: item.origem_mercadoria,
                        tipo: item.tipo,
                        urlImage: item.url,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete,
                        grade: {
                            id: item.id,
                            idProduto: item.id_produto,
                            codBarraRef: item.cod_barra_ref,
                            saldoEstoque: item.saldo_estoque,
                            variacao: item.id_variacao,
                            subVariacao: item.id_sub_variacao
                        },
                        description: item.descricao,
                        isGrade: item.grade.length > 0,
                        nome_fornecedor: item.nome_fornecedor,
                        dt_ult_compra: item.dt_ult_compra,
                        id_fornec_ult_compra: item.id_fornec_ult_compra,
                        vl_custo_ult_compra: item.vl_custo_ult_compra,
                        num_nf_ult_compra: item.num_nf_ult_compra,
                        qtd_ult_compra: item.qtd_ult_compra,

                    })
                })

            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: produtos
            }
        }

        return {
            error: false,
            data: produtos
        }
    },

    FilterEstoque: async (field: string, filter: string, type: string, filterProdutoEstoque?: any): Promise<RetAPI> => {

        const resp = await Api('Produto/filter/estoque', 'get', {
            field,
            filter,
            type,
            id_marca: filterProdutoEstoque?.id_marca,
            id_grupo: filterProdutoEstoque?.id_grupo,
            status: filterProdutoEstoque?.status,
            tipo_estoque: filterProdutoEstoque?.tipo_estoque,
        })
        const produtosEstoque: ProdutoEstoque[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: produtosEstoque
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.produtos.map((item: any) => {

                    const produto_estoque: any = {
                        id: item.id_prod,
                        id_empresa: item.id_empresa,
                        descricao: item.desc_prod,
                        preco_v: item.preco_v,
                        preco_c: item.preco_c,
                        estoque_fisico: item.estoque_fisico,
                        ativo: item.ativo,
                        description: item.desc_prod,
                        total_custo: item.total_custo,
                        total_venda: item.total_venda,
                        grades: []
                    }

                    item.grades.map((it: any) => {
                        produto_estoque.grades.push({
                            id: it.id,
                            idProduto: it.id_produto,
                            codBarraRef: it.cod_barra_ref,
                            variacao: it.nome_variacao,
                            subVariacao: it.nome_subvariacao,
                            saldoEstoque: it.saldo_estoque,
                        })
                    })

                    produtosEstoque.push(produto_estoque)
                })

            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: produtosEstoque
            }
        }

        return {
            error: false,
            data: produtosEstoque
        }
    },

    RemoveImage: async (idImagem: string): Promise<RetAPI> => {

        const resp = await Api('Produto/Image/Delete?id_image=' + idImagem, 'delete', {}, true)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

    },

    AddImage: async (idProd: string, file: File): Promise<RetAPI> => {

        const formData = new FormData()
        formData.append("id_prod", idProd)
        formData.append("imagem", file)

        const resp = await Api('Produto/Image/Save', 'post', formData, true)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
                id: resp.data.idImagem,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

    },

    AddVariacao: async (descricao: string, tipo: string): Promise<RetAPI> => {

        const resp = await Api('VariacaoProduto/save', 'post', { descricao, tipo })
        let variacoesList: VariacaoProduto[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.variacoes) {
                    variacoesList = await resp.data.variacoes.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.descricao,
                            tipo: item.tipo,
                        }
                    })
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

        return {
            error: false,
            msg: '',
            data: variacoesList
        }

    },

    DeleteVariacao: async (idVariacao: number): Promise<RetAPI> => {

        const resp = await Api('VariacaoProduto/delete?id=' + idVariacao.toString(), 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || '',
            }
        }

        const variacaoList: VariacaoProduto = await resp.data.variacao.map((item: any) => {
            return {
                id: item.id,
                description: item.descricao,
                tipo: item.tipo,
            }
        })

        return {
            error: false,
            msg: "",
            data: variacaoList,
        }

    },

    SaveGrade: async (variacao: GradeProduto): Promise<RetAPI> => {

        const data = {
            id: variacao.id,
            qtd: variacao.saldoEstoque,
            id_variacao: variacao.variacao?.id || 0,
            id_sub_variacao: variacao.subVariacao?.id || '',
            cod_barra_ref: variacao.codBarraRef,
            id_produto: variacao.idProduto || 0,
        }
        const resp = await Api('GradeProduto/Save', 'post', data)
        const grade: GradeProduto = {
            idProduto: 0,
            codBarraRef: '',
            variacao: {
                id: 0,
                description: '',
                tipo: 'S'
            },
            saldoEstoque: 0
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.grade) {
                    grade.id = resp.data.id
                    grade.codBarraRef = resp.data.cod_barra_ref
                    grade.variacao.id = resp.data.id_variacao
                    grade.saldoEstoque = resp.data.saldo_estoque

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }

        return {
            error: false,
            msg: '',
            data: grade
        }
    },

    DeleteGrade: async (idGrade: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`GradeProduto/Delete?id=${idGrade.toString()}&motivo_exclusao=${motivo}&senha_usuario=${senha}`, 'delete')

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: "",
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }
    },

    ListarGrade: async (id_produto: number): Promise<RetAPI> => {

        const resp = await Api('GradeProduto/List?id_produto=' + id_produto.toString(), 'get')
        const grade: GradeProduto[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: grade
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.grade.map((item: any) => {
                    return grade.push({
                        id: item.id,
                        idProduto: item.id_produto,
                        codBarraRef: item.cod_barra_ref,
                        variacao: { id: item.id_variacao, description: item.desc_variacao, tipo: item.tipo, },
                        subVariacao: { id: item.id_sub_variacao, description: item.desc_sub_variacao, tipo: item.tipo, },
                        saldoEstoque: item.saldo_estoque,
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: grade
            }
        }

        return {
            error: false,
            data: grade
        }
    },

    FilterGrade: async (relProduto?: any): Promise<RetAPI> => {

        const resp = await Api('GradeProduto/Filter', 'get', {
            id_produto: relProduto.id_produto,
            id_variacao: relProduto?.id_variacao,
            id_sub_variacao: relProduto?.id_sub_variacao,
            referencia: relProduto?.referencia
        })
        const grade: GradeProduto[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: grade
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.grade.map((item: any) => {
                    return grade.push({
                        id: item.id,
                        idProduto: item.id_produto,
                        codBarraRef: item.cod_barra_ref,
                        variacao: { id: item.id_variacao, description: item.desc_variacao, tipo: item.tipo, },
                        subVariacao: { id: item.id_sub_variacao, description: item.desc_sub_variacao, tipo: item.tipo, },
                        saldoEstoque: item.saldo_estoque,
                    })
                })

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: grade
            }
        }

        return {
            error: false,
            data: grade
        }
    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('Produto/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const produto: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: produto
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.produtos.map((item: any) => {
                    return produto.push({

                        id: item.id_prod,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao,
                        preco_v: item.preco_v,
                        estoque: item.estoque

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: produto
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: produto,
        }
    },

    ProdutoList: async (): Promise<RetAPI> => {

        const resp = await Api('Produto/list', 'get',)
        const produto: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: produto
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.produtos.map((item: any) => {

                    return produto.push({
                        id: item.id,
                        descricao: item.descricao,
                        description: item.descricao

                    })
                })

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: produto
            }
        }

        return {
            error: false,
            data: produto
        }

    },

    ProdutoImportacao: async (planilha: any, mapa: any): Promise<RetAPI> => {

        const formData = new FormData()
        formData.append("mapa", JSON.stringify(mapa))
        formData.append("planilha", planilha)

        const resp = await Api('Importacao/Produtos', 'post', formData)

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }
    }

}
